export const EXPORT_TYPE = { INDIVIDUAL: "individual", GROUP: "group" }

export const SELECTED_PERIOD = { SESSION_DATES: 3, PERSONALIZED_DATES: 2, SINCE_STUDENT_CREATION: 1 }